import React, { useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../contexts/AuthContext.js";
import "./SaveScheduleModal.css";

const SaveScheduleModal = ({
  isOpen,
  onClose,
  onSave,
  studentCount,
  coachCount,
  courseCount,
  possibleCourseCount,
}) => {
  const { user } = useAuth();

  const [name, setName] = useState(() => {
    const now = new Date();
    const dateStr = now.toLocaleString("de-DE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
    const firstName = user?.firstName || "Unknown";
    return `${firstName} - Plan vom ${dateStr}`;
  });
  const [description, setDescription] = useState("");

  const handleSave = () => {
    if (!name.trim()) {
      toast.warning("Bitte geben Sie einen Namen ein");
      return;
    }
    onSave({ name, description });
    setDescription("");
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Zeitplan speichern</h2>

        <div className="form-field">
          <label htmlFor="plan-name">Name des Plans *</label>
          <input
            id="plan-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="z.B. Sommerplan 2025"
          />
        </div>

        <div className="form-field">
          <label htmlFor="plan-description">Beschreibung (optional)</label>
          <textarea
            id="plan-description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Notizen zu diesem Plan..."
            rows={3}
          />
        </div>

        <div className="plan-preview">
          <strong>Vorschau:</strong>
          <div className="preview-stats">
            <span>👥 {studentCount} Schüler</span>
            <span>👨‍🏫 {coachCount} Trainer</span>
            <span>
              📅 {courseCount} Kurse belegt von {possibleCourseCount} möglichen
              Kursen
            </span>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Abbrechen
          </button>
          <button className="btn-primary" onClick={handleSave}>
            Speichern
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveScheduleModal;
